import { Pipe, PipeTransform } from '@angular/core';
import { Transfer } from '../branch-manager-dashboard/branch-manager-dashboard.component';

@Pipe({
  name: 'searchTransferSummaries'
})
export class SearchTransferSummariesPipe implements PipeTransform {

  transform(transfers: Transfer[], searchTerm: string): Transfer[] {
    if (!searchTerm) {
      return transfers;
    }

    const term = searchTerm.toLowerCase();

    return transfers.filter(t =>
      t.makeModel.toLowerCase().includes(term) ||
      t.chassisNo.toLowerCase().includes(term) ||
      t.driver.toLowerCase().includes(term) ||
      (t.from?.toLowerCase().includes(term) ?? false) ||
      (t.to?.toLowerCase().includes(term) ?? false)
    );
  }

}
